export const Users = {
    isSuporte(user) {
        return user.email === "suporte@superlogica.com"&&user.id === "999999999998";
    }
};


// WEBPACK FOOTER //
// ./src/utils/Users.js